import React from "react";
import { formatNumber } from "./warehouse-utils";

/** Список позиций, по которым проведение уведёт остаток склада-отправителя в минус. */
const WarehouseShortageList = ({ idDoc, items }) => (
  <>
    <div>
      {idDoc ? `Накладная #${idDoc}. ` : ""}
      Остаток на складе-отправителе уйдёт в минус:
    </div>
    <ul className="warehouse-documents__shortages">
      {items.map((item) => (
        <li key={item.idTov}>
          {item.name} — нужно {formatNumber(item.kol)}, остаток {formatNumber(item.rest)} {item.funit}
        </li>
      ))}
    </ul>
  </>
);

export default WarehouseShortageList;
